import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DisplayedProduct } from 'src/app/pages/tunnel/common/base-complementary-product/base-complementary-product.component';
import { faHeart, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { KitchenService } from 'src/app/services/configurators-2d/applications/kitchen.service';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { ComplementaryProductFavoriteService } from 'src/app/services/complementary-products/complementary-product-favorite.service';

@Component({
  selector: 'ng-casto-complementary-product-card',
  templateUrl: './complementary-product-card.component.html',
})
export class ComplementaryProductCardComponent {
  private complementaryProductFavoriteService = inject(ComplementaryProductFavoriteService);
  @Input() product?: DisplayedProduct;
  @Input() skeleton?: boolean;
  @Input() isImageLoaded? = false;

  @Output() onImageLoad = new EventEmitter<boolean>();
  @Output() onProductQuantityChange = new EventEmitter<{
    quantity: number;
  }>();

  protected kitchenService = inject(KitchenService);
  protected tunnelDataStore = inject(TunnelDataStore);

  protected readonly faMinus = faMinus;
  protected readonly faPlus = faPlus;
  protected readonly productPlaceholderImageSrc: string = 'assets/img/complementary-product-placeholder.png';

  protected productPicturePathFromContext(product: DisplayedProduct): string {
    if (!product.picture) return this.productPlaceholderImageSrc;
    const context = this.tunnelDataStore.getCurrentStateValue().mainContext;
    switch (context) {
      case CONFIG_CONTEXT.KITCHEN:
        return this.kitchenService.apiUrl + product.picture.path;
    }
  }

  public openProductLink(product: DisplayedProduct) {
    if (!product.link) return;

    const productWindow = window.open('', 'product_window_' + product.ean);
    if (!productWindow || productWindow.closed) {
      productWindow.location.href = product.link;
    } else {
      productWindow.location.replace(product.link);
    }
  }

  protected incrementProductQuantity(): void {
    const quantity = this.product.quantity + 1;
    this.emitOnProductQuantityChange(quantity);
  }

  protected decrementProductQuantity(): void {
    const quantity = this.product.quantity - 1;
    this.emitOnProductQuantityChange(quantity);
  }

  protected onInputChange(event: InputNumberInputEvent): void {
    this.emitOnProductQuantityChange(event.value as number);
  }

  protected emitOnProductQuantityChange(quantity: number): void {
    this.onProductQuantityChange.emit({
      quantity: quantity,
    });
  }

  protected async toggleFavorite(): Promise<void> {
    if (this.product.inFavorite) {
      await this.complementaryProductFavoriteService.removeFavorite(this.product);
    } else {
      await this.complementaryProductFavoriteService.addFavorite(this.product);
    }
  }

  protected readonly faHeart = faHeart;
}
